import * as React from "react";
import i18n from "../i18n";
import { getCurrentUser } from "../shared/getCurrentUser";
import { NavBarContainer } from "./NavBarContainer";
import { UserInfoAndLicencesSection } from "./UserInfoAndLicencesSection";

export function BuyDinLabel() {
  const userInfo = getCurrentUser()!;

  return (
    <NavBarContainer title="">
      <UserInfoAndLicencesSection userInfo={userInfo} />
      <p>{i18n.t("buy.welcome", { name: userInfo.Name })}</p>
    </NavBarContainer>
  );
}
